import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({

    // width: "100%",
    // marginTop: theme.spacing(1),
    fullColumn: {
        flexBasis: "100%"
    },

}));

export const Form = ({ children, ...props }) => {
    const styles = useStyles();

    return (
        <form {...props} className={styles.fullColumn} noValidate>
            {children}
        </form>
    );
};
